<template>
    <div ref="container">
      <a-modal :top="1" :title="title" height="95%" width="96%" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'3px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:1%;height: 70%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据编号" prop="code">
                  <a-input placeholder="请输入单据编号" v-model="form.code" onblur="isRepeat"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请部门" prop="department">
                  <a-input placeholder="请输入申请部门" v-model="form.department" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销毁地点" prop="place">
                  <a-input placeholder="请输入销毁地点" v-model="form.place" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销毁单位" prop="destructionUnit">
                  <a-input placeholder="请输入销毁单位" v-model="form.destructionUnit" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销毁原因" prop="destructionReason">
                  <a-input placeholder="请输入销毁原因" v-model="form.destructionReason" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人" prop="applicant">
                  <a-input placeholder="请输入申请人" v-model="form.applicant" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="仓库" prop="warehouse">
                  <a-input placeholder="请输入仓库" v-model="form.warehouse" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="制单人" prop="preparedBy">
                  <a-input placeholder="请输入制单人" v-model="form.preparedBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="制单时间" prop="preparedTime">
                  <JDate placeholder="请输入制单时间" v-model="form.preparedTime"></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { certificateDetail, handledAdd, handledEdit } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDate from '../../../components/jeecg/JDate.vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        JImageUpload,
        JDate,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: '',
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          registerName: '',
          registerNo: '',
          registerImage: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          code: [{ required: true, message: '请填写单据编号' }],
          department: [{ required: true, message: '请输入申请部门' }],
          destructionReason: [{ required: true, message: '请输入销毁原因' }],
          preparedBy: [{ required: true, message: '请输入制单人' }],
          preparedTime: [{ required: true, message: '请输入制单时间' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.getInfo(record.id)
          this.id = record.id
        } else {
          this.fileList = ''
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      async getInfo(id) {
        this.confirmLoading = true
        const res = await certificateDetail({ id })
        console.log(res, 'res---')
        if (res.errno == 200 && res.errmsg == '成功') {
          this.form = res.data
          if (res.data.registerImage) {
            this.fileList = res.data.registerImage
          }
          this.confirmLoading = false
        } else {
          this.$message.error(res.data || res.errmsg)
          this.confirmLoading = false
        }
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            console.log(this.form, 'form---')
            // console.log(this.fileList, '图片数组')
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              code: this.form.code || '',
              date: this.form.date || '',
              place: this.form.place || '',
              destructionUnit: this.form.destructionUnit || '',
              destructionReason: this.form.destructionReason || '',
              department: this.form.department || '',
              applicant: this.form.applicant || '',
              warehouse: this.form.warehouse || '',
              preparedBy: this.form.preparedBy || '',
              preparedTime: this.form.preparedTime || '',
              attachment: this.fileList || '',
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await handledEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.handleCancel()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await handledAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>